export enum NotificationSlugs {
  item_created = 'item_created',
  workspace_comment_created = 'workspace_comment_created',
  item_assigned = 'item_assigned',
}

export type NotificationType = {
  type: NotificationSlugs;
};
